export const OrdersQueryKeys = {
  Search: "ecommerce-search-orders",
  Invoices: "ecommerce-order-invoices",
  FilterValues: "ecommerce-order-filter-values",
  ShippingDetails: "ecommerce-order-shipping-details",
  BillTo: "ecommerce-order-bill-to",
  ShipmentTracking: "ecommerce-order-shipment-tracking",
  OrderLineRelatedData: "ecommerce-order-line-related-data",
  OrderLineSerials: "ecommerce-order-line-serials",
  OrderLineProductAvailability: "ecommerce-order-line-product-availability",
  OrderProductDetailsDrawer: "ecommerce-order-product-detail-drawer",
  OrderProductDetailsDrawerImages: "ecommerce-order-product-detail-drawer-images",
  RmaDetail: "ecommerce-order-rma-detail",
} as const;